//import { FSPUomDroOpts } from "presentation/constant/DropDownOptions/Company/FSPUomDroOpts";
import { MasterFSPMaintenanceConstant } from "presentation/constant/MasterFSP/MasterFSPMaintenanceConstant";
import { useMasterFSPMaintenanceVM } from "presentation/hook/MasterFSP/useMasterFSPMaintenanceVM";
//import { useANAInfoTracked } from "presentation/store/ANAInfo";
import { useANAInfoTracked } from "presentation/store/ANAInfo";
import { useMasterFSPMaintenanceTracked } from "presentation/store/MasterFSP/MasterFSPMaintenanceProvider";
import { CriteriaItemContainer } from "presentation/view/components/CriteriaItemContainer";
import DatePickerComponent from "presentation/view/components/DatePickerComponent";
import { FieldType, IFieldValue, NbisCommonField } from "presentation/view/components/NbisCommonField";
import { useCallback, useEffect, useMemo, useState } from "react";
import { HPHCheckbox, Loader } from "veronica-ui-component/dist/component/core";
import { SidebarCaption, StyledSidebar } from "veronica-ui-component/dist/component/core/styled/uiFramework.styled";
import MasterFSPEditPanelTitleBar from "./MasterFSPEditPanelTitleBar";
//import { FSPCountingDroOpts } from "presentation/constant/DropDownOptions/Company/FSPCountingDroOpts";
import _ from "lodash";
import NumberInputComponent from "presentation/view/components/NumberInputComponent";

export const MasterFSPMaintenanceFormPanel = () => {
    const [masterFSPState] = useMasterFSPMaintenanceTracked();
    const masterFSPVM = useMasterFSPMaintenanceVM();
    const [anainfoState] = useANAInfoTracked();
    const { operatingUnit } = anainfoState;
    const { masterState } = masterFSPState;
    const { editingEntity, isRead, isSaveClicked, allFormState, isAdd, isEditable } = masterState;
    const SCREEN_CONSTANT = MasterFSPMaintenanceConstant;
    const [isLoading, setIsLoading] = useState(false);
    const [isInitFormData, setIsInitFormData] = useState(true);

    const currentEntity = editingEntity;

    useEffect(() => {
        if (masterFSPState.isShowEditPanel && isInitFormData) {
            setIsInitFormData(false);
            setIsLoading(true);
            Promise.allSettled([
                masterFSPVM.reLoadDropdownOption(operatingUnit)
            ]).then(data => {
                if (isAdd) {
                    masterFSPVM.onInitDefaultValue(masterFSPState);
                }
                setIsLoading(false);
            }).catch(error => {
                setIsLoading(false);
            });
        }
    }, [anainfoState.operatingUnit, isAdd, isInitFormData, masterFSPState, masterFSPVM, operatingUnit]);

    const memoSubChgTypeOptions = useMemo(() => {
        const subChgTypeOptions = currentEntity.chargeType ? masterFSPState.dynamicOptions.subChargeTypeDropdownOptions[currentEntity.chargeType] : [];
        return subChgTypeOptions;
    }, [currentEntity.chargeType, masterFSPState.dynamicOptions.subChargeTypeDropdownOptions])

    const memoDirectionOptions = useMemo(() => {
        const directionKey = currentEntity.chargeType + "_" + currentEntity.subChargeType;
        const directionOptions = masterFSPState.dynamicOptions.directionDropdownOptions[directionKey];
        const tempDirectionDroOpts = masterFSPState.dynamicOptions.directionDropdownOptions[(currentEntity.chargeType + "_")]

        const newDirectionDroOpts = _.unionBy(directionOptions, tempDirectionDroOpts, "value");

        return newDirectionDroOpts;
    }, [currentEntity.chargeType, currentEntity.subChargeType, masterFSPState.dynamicOptions.directionDropdownOptions])

    const onSubChargeTypeChange = useCallback((fieldKey: string, fieldValue: any) => {
        masterFSPVM.onSubChargeTypeChange(fieldKey, currentEntity.chargeType ?? "", fieldValue, operatingUnit);
    }, [masterFSPVM, currentEntity.chargeType, operatingUnit])

    /*const selectedFspCountingFromVal = useMemo(() => {
        const newChageType = masterFSPVM.getChargeTypeForCC(currentEntity.chargeType ?? "", currentEntity.subChargeType ?? "");
        return FSPCountingDroOpts(operatingUnit).getFromValueByKey(newChageType, currentEntity.fspCountingFrom ?? "");
    }, [currentEntity.chargeType, currentEntity.fspCountingFrom, currentEntity.subChargeType, masterFSPVM, operatingUnit])

    const selectedFspCountingToVal = useMemo(() => {
        const newChageType = masterFSPVM.getChargeTypeForCC(currentEntity.chargeType ?? "", currentEntity.subChargeType ?? "");
        return FSPCountingDroOpts(operatingUnit).getToValueByKey(newChageType, currentEntity.fspCountingTo ?? "");
    }, [currentEntity.chargeType, currentEntity.fspCountingTo, currentEntity.subChargeType, masterFSPVM, operatingUnit])*/

    const isCalcBySplitDay = useMemo(() => {
        if ("By Splitting Day" === currentEntity.fspCalculateMethod) return true;

        return false;
    }, [currentEntity.fspCalculateMethod])

    const onNumberFieldChange = useCallback((e: any, fieldName: string, fieldValue: any) => {
        masterFSPVM.onFieldChange(fieldName, fieldValue);
    }, [masterFSPVM]);

    const memoPriority = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "330px", marginBottom: "24px" }}>
            <NbisCommonField
                isReadOnly={true}
                isShowOptional={true}
                readOnlyValue={isAdd ? '' : currentEntity?.priority?.toString() ?? ''}
                fieldValue={currentEntity?.priority?.toString() ?? ''}
                fieldLabel={SCREEN_CONSTANT.PRIORITY}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.TEXT}
                fieldKey={'priority'}
                maxLength={60}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    masterFSPVM.onFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [currentEntity?.priority, isSaveClicked, masterFSPVM, SCREEN_CONSTANT.PRIORITY, isAdd])

    const memoStatus = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "330px", marginBottom: "24px" }}>
            <NbisCommonField
                isReadOnly={true}
                isShowOptional={true}
                readOnlyValue={currentEntity?.status ?? ''}
                fieldValue={currentEntity?.status}
                fieldLabel={SCREEN_CONSTANT.STATUS}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.TEXT}
                fieldKey={'status'}
                maxLength={10}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    masterFSPVM.onFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [currentEntity?.status, SCREEN_CONSTANT.STATUS, isSaveClicked, masterFSPVM])

    const memoEffectiveDateFrom = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "330px", marginBottom: "24px" }}>
            <DatePickerComponent
                disabled={isRead}
                label={SCREEN_CONSTANT.EFFECTIVE_DATE_FROM}
                width="330px"
                optional={false}
                date={currentEntity?.effectiveDateFrom}
                fieldName="effectiveDateFrom"
                errorMessage={allFormState ? allFormState["effectiveDateFrom"] : ""}
                onDateChange={masterFSPVM.onFieldChange} />
        </div>
        , [isRead, SCREEN_CONSTANT.EFFECTIVE_DATE_FROM, currentEntity?.effectiveDateFrom, allFormState, masterFSPVM.onFieldChange])

    const memoEffectiveDateTo = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "330px", marginBottom: "24px" }}>
            <DatePickerComponent
                disabled={isRead}
                label={SCREEN_CONSTANT.EFFECTIVE_DATE_TO}
                width="330px"
                optional={false}
                date={currentEntity?.effectiveDateTo}
                fieldName="effectiveDateTo"
                errorMessage={allFormState ? allFormState["effectiveDateTo"] : ""}
                onDateChange={masterFSPVM.onFieldChange} />
        </div>
        , [isRead, SCREEN_CONSTANT.EFFECTIVE_DATE_TO, currentEntity?.effectiveDateTo, allFormState, masterFSPVM.onFieldChange])

    // const memoEffectiveDateFromTo = useMemo(() =>
    //     <div className='im-flex-row-item' style={{ width: "330px", marginBottom: "24px" }}>
    //         <DateRangePickerComponent
    //             disabled={isRead}
    //             label={MasterFSPMaintenanceConstant.EFFECTIVE_DATE_RANGE}
    //             width='330px'
    //             fieldNames={{ startField: "effectiveDateFrom", endField: "effectiveDateTo" }}
    //             dateRange={{ startDate: currentEntity.effectiveDateFrom, endDate: currentEntity.effectiveDateTo }}
    //             onDatesChange={masterFSPVM.onDateRangeChangeFroEdit}
    //         />
    //     </div>
    //     , [currentEntity.effectiveDateFrom, currentEntity.effectiveDateTo, masterFSPVM.onDateRangeChangeFroEdit, isRead])

    const memoShippingLine = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "330px", marginBottom: "24px" }}>
            <NbisCommonField
                isReadOnly={isRead}
                isShowOptional={true}
                readOnlyValue={currentEntity?.shippingLine ?? ''}
                fieldValue={currentEntity?.shippingLine}
                fieldLabel={SCREEN_CONSTANT.SHIPPING_LINE}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'shippingLine'}
                maxLength={10}
                options={masterFSPState.dynamicOptions.shippingLineCompanyDropdownOptions}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    masterFSPVM.onFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [currentEntity?.shippingLine, SCREEN_CONSTANT.SHIPPING_LINE, isSaveClicked, isRead, masterFSPState.dynamicOptions.shippingLineCompanyDropdownOptions, masterFSPVM])

    const memoConsortiumCode = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "330px", marginBottom: "24px" }}>
            <NbisCommonField
                isReadOnly={isRead}
                isShowOptional={true}
                readOnlyValue={currentEntity?.consortiumCode ?? ''}
                fieldValue={currentEntity?.consortiumCode}
                fieldLabel={SCREEN_CONSTANT.CONSORTIUM_CODE}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'consortiumCode'}
                maxLength={10}
                options={masterFSPState.dynamicOptions.consortiumCodeDropdownOptions}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    masterFSPVM.onFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [currentEntity?.consortiumCode, SCREEN_CONSTANT.CONSORTIUM_CODE, isSaveClicked, isRead, masterFSPState.dynamicOptions.consortiumCodeDropdownOptions, masterFSPVM])

    const memoServiceCode = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "330px", marginBottom: "24px" }}>
            <NbisCommonField
                isReadOnly={isRead}
                isShowOptional={true}
                readOnlyValue={currentEntity?.serviceCode ?? ''}
                fieldValue={currentEntity?.serviceCode}
                fieldLabel={SCREEN_CONSTANT.SERVICE_CODE}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'serviceCode'}
                maxLength={10}
                options={masterFSPState.dynamicOptions.serviceCodeDropdownOptions}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    masterFSPVM.onFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [currentEntity?.serviceCode, SCREEN_CONSTANT.SERVICE_CODE, isSaveClicked, isRead, masterFSPState.dynamicOptions.serviceCodeDropdownOptions, masterFSPVM])

    const memoChargeType = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "330px", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={isRead}
                isShowOptional={false}
                readOnlyValue={currentEntity?.chargeType ?? ''}
                fieldValue={currentEntity?.chargeType}
                fieldLabel={SCREEN_CONSTANT.CHARGE_TYPE}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'chargeType'}
                isShowMissingError={true}
                maxLength={10}
                options={masterFSPState.dynamicOptions.chargeTypeDropdownOptions}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    masterFSPVM.onChargeTypeChange(fieldKey, fieldValue && fieldValue.toString(), operatingUnit, fFullValue)} />
        </div>
        , [allFormState, isRead, currentEntity?.chargeType, SCREEN_CONSTANT.CHARGE_TYPE, isSaveClicked, masterFSPState.dynamicOptions.chargeTypeDropdownOptions, masterFSPVM, operatingUnit])

    const memoSubChargeType = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "330px", marginBottom: "24px" }}>
            <NbisCommonField
                isReadOnly={isRead}
                isShowOptional={true}
                readOnlyValue={currentEntity?.subChargeType ?? ''}
                fieldValue={currentEntity?.subChargeType}
                fieldLabel={SCREEN_CONSTANT.SUB_CHARGE_TYPE}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'subChargeType'}
                maxLength={10}
                options={memoSubChgTypeOptions}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    onSubChargeTypeChange(fieldKey, fieldValue && fieldValue.toString())} />
        </div>
        , [isRead, currentEntity?.subChargeType, SCREEN_CONSTANT.SUB_CHARGE_TYPE, isSaveClicked, memoSubChgTypeOptions, onSubChargeTypeChange])

    const memoShipmentType = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "330px", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={isRead}
                isShowOptional={false}
                readOnlyValue={currentEntity?.shipmentType ?? ''}
                fieldValue={currentEntity?.shipmentType?.split(",")?.filter(item => item.trim() !== '') ?? ''}
                fieldLabel={SCREEN_CONSTANT.SHIPMENT_TYPE}
                allValues={currentEntity?.shipmentType ?? ''}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'shipmentType'}
                isShowMissingError={true}
                maxLength={10}
                isMultipleDropDown={true}
                options={masterFSPState.dynamicOptions.shipmentTypeDropdownOptions}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    masterFSPVM.onFieldChange(fieldKey, fieldValue && fieldValue as string[], fFullValue)} />
        </div>
        , [allFormState, currentEntity?.shipmentType, SCREEN_CONSTANT.SHIPMENT_TYPE, isSaveClicked, isRead, masterFSPState.dynamicOptions.shipmentTypeDropdownOptions, masterFSPVM])

    const memoCntrMovement = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "330px", marginBottom: "24px" }}>
            <NbisCommonField
                isReadOnly={isRead}
                isShowOptional={true}
                readOnlyValue={currentEntity?.cntrMovement ?? ''}
                fieldValue={currentEntity?.cntrMovement}
                fieldLabel={SCREEN_CONSTANT.CONTAINER_MOVEMENT}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'cntrMovement'}
                maxLength={10}
                options={masterFSPState.dynamicOptions.cntrMovementDropdownOptions}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    masterFSPVM.onFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [currentEntity?.cntrMovement, SCREEN_CONSTANT.CONTAINER_MOVEMENT, isSaveClicked, isRead, masterFSPState.dynamicOptions.cntrMovementDropdownOptions, masterFSPVM])

    const memoCntrStatus = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "330px", marginBottom: "24px" }}>
            <NbisCommonField
                isReadOnly={isRead}
                isShowOptional={true}
                readOnlyValue={currentEntity?.cntrStatus ?? ''}
                fieldValue={currentEntity?.cntrStatus}
                fieldLabel={SCREEN_CONSTANT.CONTAINER_STATUS}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'cntrStatus'}
                maxLength={10}
                options={masterFSPState.dynamicOptions.cntrStatusDropdownOptions}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    masterFSPVM.onFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [currentEntity?.cntrStatus, SCREEN_CONSTANT.CONTAINER_STATUS, isSaveClicked, isRead, masterFSPState.dynamicOptions.cntrStatusDropdownOptions, masterFSPVM])

    const memoForwarderCode = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "330px", marginBottom: "24px" }}>
            <NbisCommonField
                isReadOnly={isRead}
                isShowOptional={true}
                readOnlyValue={currentEntity?.forwarderCode ?? ''}
                fieldValue={currentEntity?.forwarderCode?.split(",").filter(item => item.trim() !== '') ?? ''}
                allValues={currentEntity?.forwarderCode ?? ''}
                fieldLabel={SCREEN_CONSTANT.CONSIGNEE_SHIPPER_FORWARDER}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.DROPDOWN}
                isMultipleDropDown={true}
                fieldKey={'forwarderCode'}
                maxLength={10}
                options={masterFSPState.dynamicOptions.forwarderCodeDropdownOptions}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    masterFSPVM.onFieldChange(fieldKey, fieldValue && fieldValue as string[], fFullValue)} />
        </div>
        , [currentEntity?.forwarderCode, SCREEN_CONSTANT.CONSIGNEE_SHIPPER_FORWARDER, isSaveClicked, isRead, masterFSPState.dynamicOptions.forwarderCodeDropdownOptions, masterFSPVM])

    const memoAgentCode = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "330px", marginBottom: "24px" }}>
            <NbisCommonField
                isReadOnly={isRead}
                isShowOptional={true}
                readOnlyValue={currentEntity?.agentCode ?? ''}
                fieldValue={currentEntity?.agentCode?.split(",").filter(item => item.trim() !== '') ?? ''}
                allValues={currentEntity?.agentCode ?? ''}
                fieldLabel={SCREEN_CONSTANT.AGENT_CODE}
                isMultipleDropDown={true}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'agentCode'}
                maxLength={10}
                options={masterFSPState.dynamicOptions.agentInfosDropdownOptions}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    masterFSPVM.onFieldChange(fieldKey, fieldValue && fieldValue as string[], fFullValue)} />
        </div>
        , [currentEntity?.agentCode, SCREEN_CONSTANT.AGENT_CODE, isSaveClicked, isRead, masterFSPState.dynamicOptions.agentInfosDropdownOptions, masterFSPVM])

    const memoCustomerType = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "330px", marginBottom: "24px" }}>
            <NbisCommonField
                isReadOnly={isRead}
                isShowOptional={true}
                readOnlyValue={currentEntity?.customerType ?? ''}
                fieldValue={currentEntity?.customerType}
                fieldLabel={SCREEN_CONSTANT.BILL_TO_COMPANY_CUSTOMER_TYPE}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'customerType'}
                maxLength={10}
                options={masterFSPState.dynamicOptions.customerTypeDropdownOptions}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    masterFSPVM.onFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [currentEntity?.customerType, SCREEN_CONSTANT.BILL_TO_COMPANY_CUSTOMER_TYPE, isSaveClicked, isRead, masterFSPState.dynamicOptions.customerTypeDropdownOptions, masterFSPVM])

    const memoFspDays = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "330px", marginBottom: "24px" }}>
            {/* <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={isRead}
                isShowOptional={false}
                readOnlyValue={currentEntity?.fspDays?.toString() ?? ''}
                fieldValue={currentEntity?.fspDays?.toString()}
                fieldLabel={SCREEN_CONSTANT.FSP_DAYS}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.TEXT}
                fieldKey={'fspDays'}
                isShowMissingError={true}
                maxLength={10}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) => {
                    const numericValue = fieldValue && fieldValue.toString().replace(/[^0-9]/g, '');
                    masterFSPVM.onFieldChange(fieldKey, numericValue, fFullValue);
                }} /> */}
            <NumberInputComponent
                label={SCREEN_CONSTANT.FSP_DAYS}
                maxLength={10}
                width="280px"
                fieldName={"fspDays"}
                value={currentEntity?.fspDays?.toString() ?? ''}
                errorMessage={allFormState ? allFormState["fspDays"] : ""}
                disabled={isRead}
                onChange={(e: any, fieldKey: string, fieldValue: any) => onNumberFieldChange(e, fieldKey, fieldValue)}
            />
        </div>
        , [SCREEN_CONSTANT.FSP_DAYS, currentEntity?.fspDays, allFormState, isRead, onNumberFieldChange])

    const memoFspUOM = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "330px", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={isRead}
                isShowOptional={false}
                readOnlyValue={currentEntity?.fspUOM ?? ''}
                fieldValue={currentEntity?.fspUOM}
                fieldLabel={SCREEN_CONSTANT.UOM}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'fspUOM'}
                isShowMissingError={true}
                maxLength={10}
                options={masterFSPState.dynamicOptions.fspUomDropdownOptions}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    masterFSPVM.onFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [allFormState, isRead, currentEntity?.fspUOM, SCREEN_CONSTANT.UOM, isSaveClicked, masterFSPState.dynamicOptions.fspUomDropdownOptions, masterFSPVM])

    const memoCargoCode = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "330px", marginBottom: "24px" }}>
            <NbisCommonField
                isReadOnly={isRead}
                isShowOptional={true}
                readOnlyValue={currentEntity?.cargoCode ?? ''}
                fieldValue={currentEntity?.cargoCode}
                fieldLabel={SCREEN_CONSTANT.CARGO_CODE}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'cargoCode'}
                maxLength={10}
                options={masterFSPState.dynamicOptions.cargeCodeDropdownOption}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    masterFSPVM.onFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [currentEntity?.cargoCode, SCREEN_CONSTANT.CARGO_CODE, isSaveClicked, isRead, masterFSPState.dynamicOptions.cargeCodeDropdownOption, masterFSPVM])

    const memoVesselCode = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "330px", marginBottom: "24px" }}>
            <NbisCommonField
                isReadOnly={isRead}
                isShowOptional={true}
                readOnlyValue={currentEntity?.vesselCode ?? ''}
                fieldValue={currentEntity?.vesselCode}
                fieldLabel={SCREEN_CONSTANT.VESSEL_CODE}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.TEXT}
                fieldKey={'vesselCode'}
                maxLength={10}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    masterFSPVM.onFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [currentEntity?.vesselCode, SCREEN_CONSTANT.VESSEL_CODE, isSaveClicked, isRead, masterFSPVM])

    const memoVoyageCode = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "330px", marginBottom: "24px" }}>
            <NbisCommonField
                isReadOnly={isRead}
                isShowOptional={true}
                readOnlyValue={currentEntity?.voyageCode ?? ''}
                fieldValue={currentEntity?.voyageCode}
                fieldLabel={SCREEN_CONSTANT.VOYAGE_CODE}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.TEXT}
                fieldKey={'voyageCode'}
                maxLength={10}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    masterFSPVM.onFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [currentEntity?.voyageCode, SCREEN_CONSTANT.VOYAGE_CODE, isSaveClicked, isRead, masterFSPVM])

    const memoGraceHourFrom = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "330px", marginBottom: "24px" }}>
            {/* <NbisCommonField
                isReadOnly={isRead}
                isShowOptional={true}
                readOnlyValue={currentEntity?.graceHourFrom?.toString() ?? ''}
                fieldValue={currentEntity?.graceHourFrom?.toString()}
                fieldLabel={SCREEN_CONSTANT.GRACE_HOUR_COUNT_FROM}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.TEXT}
                fieldKey={'graceHourFrom'}
                maxLength={10}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    masterFSPVM.onFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} /> */}
            <NumberInputComponent
                label={SCREEN_CONSTANT.GRACE_HOUR_COUNT_FROM}
                maxLength={10}
                width="280px"
                fieldName={"graceHourFrom"}
                value={currentEntity?.graceHourFrom?.toString() ?? ''}
                errorMessage={allFormState ? allFormState["graceHourFrom"] : ""}
                disabled={isRead}
                optional={true}
                onChange={(e: any, fieldKey: string, fieldValue: any) => onNumberFieldChange(e, fieldKey, fieldValue)}
            />
        </div>
        , [SCREEN_CONSTANT.GRACE_HOUR_COUNT_FROM, currentEntity?.graceHourFrom, allFormState, isRead, onNumberFieldChange])

    const memoGraceMinuteFrom = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "330px", marginBottom: "24px" }}>
            {/* <NbisCommonField
                isReadOnly={isRead}
                isShowOptional={true}
                readOnlyValue={currentEntity?.graceMinuteFrom?.toString() ?? ''}
                fieldValue={currentEntity?.graceMinuteFrom?.toString()}
                fieldLabel={SCREEN_CONSTANT.GRACE_MINUTE_COUNT_FROM}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.TEXT}
                fieldKey={'graceMinuteFrom'}
                maxLength={10}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    masterFSPVM.onFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} /> */}
            <NumberInputComponent
                label={SCREEN_CONSTANT.GRACE_MINUTE_COUNT_FROM}
                maxLength={10}
                width="280px"
                fieldName={"graceMinuteFrom"}
                value={currentEntity?.graceMinuteFrom?.toString() ?? ''}
                errorMessage={allFormState ? allFormState["graceMinuteFrom"] : ""}
                disabled={isRead}
                optional={true}
                onChange={(e: any, fieldKey: string, fieldValue: any) => onNumberFieldChange(e, fieldKey, fieldValue)}
            />
        </div>
        , [SCREEN_CONSTANT.GRACE_MINUTE_COUNT_FROM, currentEntity?.graceMinuteFrom, allFormState, isRead, onNumberFieldChange])

    const memoApplyCalendarAdj = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "330px", marginBottom: "24px" }}>
            <NbisCommonField
                isReadOnly={isRead}
                isShowOptional={true}
                readOnlyValue={currentEntity?.applyCalendarAdj ?? ''}
                fieldValue={currentEntity?.applyCalendarAdj?.split(",").filter(item => item.trim() !== '') ?? ""}
                allValues={currentEntity?.applyCalendarAdj ?? ""}
                fieldLabel={SCREEN_CONSTANT.CALENDAR_ADJ_NO_DOT}
                isSaveClicked={isSaveClicked}
                isMultipleDropDown={true}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'applyCalendarAdj'}
                maxLength={10}
                options={masterFSPState.dynamicOptions.calendarAdjDropdownOptions}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    masterFSPVM.onFieldChange(fieldKey, fieldValue && fieldValue as string[], fFullValue)} />
        </div>
        , [isRead, currentEntity?.applyCalendarAdj, SCREEN_CONSTANT.CALENDAR_ADJ_NO_DOT, isSaveClicked, masterFSPState.dynamicOptions.calendarAdjDropdownOptions, masterFSPVM])

    const memoGraceHourTo = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "330px", marginBottom: "24px" }}>
            {/* <NbisCommonField
                isReadOnly={isRead}
                isShowOptional={true}
                readOnlyValue={currentEntity?.graceHourTo?.toString() ?? ''}
                fieldValue={currentEntity?.graceHourTo?.toString()}
                fieldLabel={SCREEN_CONSTANT.GRACE_HOUR_COUNT_TO}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.TEXT}
                fieldKey={'graceHourTo'}
                maxLength={10}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    masterFSPVM.onFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} /> */}
            <NumberInputComponent
                label={SCREEN_CONSTANT.GRACE_HOUR_COUNT_TO}
                maxLength={10}
                width="280px"
                fieldName={"graceHourTo"}
                value={currentEntity?.graceHourTo?.toString() ?? ''}
                errorMessage={allFormState ? allFormState["graceHourTo"] : ""}
                disabled={isRead}
                optional={true}
                onChange={(e: any, fieldKey: string, fieldValue: any) => onNumberFieldChange(e, fieldKey, fieldValue)}
            />
        </div>
        , [SCREEN_CONSTANT.GRACE_HOUR_COUNT_TO, currentEntity?.graceHourTo, allFormState, isRead, onNumberFieldChange])

    const memoGraceMinuteTo = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "330px", marginBottom: "24px" }}>
            {/* <NbisCommonField
                isReadOnly={isRead}
                isShowOptional={true}
                readOnlyValue={currentEntity?.graceMinuteTo?.toString() ?? ''}
                fieldValue={currentEntity?.graceMinuteTo?.toString()}
                fieldLabel={SCREEN_CONSTANT.GRACE_MINUTE_COUNT_TO}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.TEXT}
                fieldKey={'graceMinuteTo'}
                maxLength={10}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    masterFSPVM.onFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} /> */}
            <NumberInputComponent
                label={SCREEN_CONSTANT.GRACE_MINUTE_COUNT_TO}
                maxLength={10}
                width="280px"
                fieldName={"graceMinuteTo"}
                value={currentEntity?.graceMinuteTo?.toString() ?? ''}
                errorMessage={allFormState ? allFormState["graceMinuteTo"] : ""}
                disabled={isRead}
                optional={true}
                onChange={(e: any, fieldKey: string, fieldValue: any) => onNumberFieldChange(e, fieldKey, fieldValue)}
            />
        </div>
        , [SCREEN_CONSTANT.GRACE_MINUTE_COUNT_TO, currentEntity?.graceMinuteTo, allFormState, isRead, onNumberFieldChange])

    const memoFspCountingFrom = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "330px", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={isRead}
                isShowOptional={false}
                readOnlyValue={/*currentEntity?.fspCountingFrom?.toString() ?? ''*/currentEntity?.fspCountingFromDisVal ?? ''}
                fieldValue={/*currentEntity?.fspCountingFrom?.toString()*/currentEntity?.fspCountingFromDisVal ?? ''}
                fieldLabel={SCREEN_CONSTANT.FSP_COUNT_FROM}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'fspCountingFromDisVal'}
                isShowMissingError={true}
                maxLength={10}
                options={masterFSPState.dynamicOptions.fspCountingFromDropdownOptions}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    masterFSPVM.onFspCountingChange(fieldKey, fieldValue && fieldValue.toString(), operatingUnit, fFullValue, "fspCountingFrom")} />
        </div>
        , [allFormState, isRead, currentEntity?.fspCountingFromDisVal, SCREEN_CONSTANT.FSP_COUNT_FROM, isSaveClicked, masterFSPState.dynamicOptions.fspCountingFromDropdownOptions, masterFSPVM, operatingUnit])

    const memoFspCountingTo = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "330px", marginBottom: "24px" }}>
            <NbisCommonField
                isReadOnly={isRead}
                isShowOptional={false}
                readOnlyValue={/*currentEntity?.fspCountingTo?.toString() ?? ''*/ currentEntity?.fspCountingToDisVal ?? ''}
                fieldValue={/*currentEntity?.fspCountingTo?.toString()*/ currentEntity?.fspCountingToDisVal ?? ''}
                fieldLabel={SCREEN_CONSTANT.FSP_COUNT_TO}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'fspCountingToDisVal'}
                maxLength={10}
                options={masterFSPState.dynamicOptions.fspCountingToDropdownOptions}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    masterFSPVM.onFspCountingChange(fieldKey, fieldValue && fieldValue.toString(), operatingUnit, fFullValue, "fspCountingTo")} />
        </div>
        , [isRead, currentEntity.fspCountingToDisVal, SCREEN_CONSTANT.FSP_COUNT_TO, isSaveClicked, masterFSPState.dynamicOptions.fspCountingToDropdownOptions, masterFSPVM, operatingUnit])

    const memoRemarks = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "1050px", marginBottom: "24px" }}>
            <NbisCommonField
                isReadOnly={isRead}
                isShowOptional={true}
                readOnlyValue={currentEntity?.remarks ?? ''}
                fieldValue={currentEntity?.remarks}
                fieldLabel={SCREEN_CONSTANT.REMARKS}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.TEXTAREA}
                fieldKey={'remarks'}
                maxLength={1333}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    masterFSPVM.onFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [currentEntity?.remarks, SCREEN_CONSTANT.REMARKS, isSaveClicked, isRead, masterFSPVM])

    const memoRejectReason = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "1050px", marginBottom: "24px" }}>
            <NbisCommonField
                isReadOnly={true}
                isShowOptional={true}
                readOnlyValue={currentEntity?.rejectReason ?? ''}
                fieldValue={currentEntity?.rejectReason}
                fieldLabel={SCREEN_CONSTANT.REJECT_REASON}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.TEXTAREA}
                fieldKey={'rejectReason'}
                maxLength={10}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    masterFSPVM.onFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [currentEntity?.rejectReason, SCREEN_CONSTANT.REJECT_REASON, isSaveClicked, masterFSPVM])

    const memoFspCountingDirection = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "330px", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={isRead}
                isShowOptional={false}
                readOnlyValue={currentEntity?.fspCountingDirection ?? ''}
                fieldValue={currentEntity?.fspCountingDirection}
                fieldLabel={SCREEN_CONSTANT.DIRECTION}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'fspCountingDirection'}
                isShowMissingError={true}
                maxLength={10}
                options={memoDirectionOptions}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    masterFSPVM.onFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [allFormState, isRead, currentEntity?.fspCountingDirection, SCREEN_CONSTANT.DIRECTION, isSaveClicked, memoDirectionOptions, masterFSPVM])

    const memoForwarderReference = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "330px", marginBottom: "24px" }}>
            <NbisCommonField
                isReadOnly={isRead}
                isShowOptional={true}
                readOnlyValue={currentEntity?.forwarderReference ?? ''}
                fieldValue={currentEntity?.forwarderReference}
                fieldLabel={SCREEN_CONSTANT.FORWARDER_REF}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.TEXT}
                fieldKey={'forwarderReference'}
                maxLength={10}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    masterFSPVM.onFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [currentEntity?.forwarderReference, SCREEN_CONSTANT.FORWARDER_REF, isSaveClicked, isRead, masterFSPVM])

    const memoFspCalculateMethod = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "330px", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={isRead}
                isShowOptional={false}
                readOnlyValue={currentEntity?.fspCalculateMethod ?? ''}
                fieldValue={currentEntity?.fspCalculateMethod}
                fieldLabel={SCREEN_CONSTANT.CALCULATION_BASIS}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'fspCalculateMethod'}
                isShowMissingError={true}
                maxLength={10}
                options={masterFSPState.dynamicOptions.fspCalculateMethodDropdownOptions}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    masterFSPVM.onFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [allFormState, currentEntity?.fspCalculateMethod, SCREEN_CONSTANT.CALCULATION_BASIS, isSaveClicked, isRead, masterFSPState.dynamicOptions.fspCalculateMethodDropdownOptions, masterFSPVM])

    const memoGraceExtend = useMemo(() =>
        <>
            <div className='im-flex-row-item' style={{ width: "330px", marginBottom: "24px" }}>
                <NbisCommonField
                    fieldKey={"graceExtend"}
                    requiredFieldList={[]}
                    fieldLabel={SCREEN_CONSTANT.GRACE_HOURS_EXTENDED}
                    fieldType={FieldType.TEXT}
                    isReadOnly={true}
                    onFieldChange={() => { }} />
                <HPHCheckbox
                    label={""}
                    checked={currentEntity?.graceExtend === 'Y'}
                    disabled={isRead}
                    onChange={(e) => masterFSPVM.onCheckboxChange(e.checked, "graceExtend")}
                />
            </div>
        </>
        , [SCREEN_CONSTANT.GRACE_HOURS_EXTENDED, currentEntity?.graceExtend, isRead, masterFSPVM])

    const memoActiveInd = useMemo(() =>
        <>
            <div className='im-flex-row-item' style={{ width: "330px", marginBottom: "24px" }}>
                <NbisCommonField
                    fieldKey={"activeInd"}
                    requiredFieldList={[]}
                    fieldLabel={SCREEN_CONSTANT.ACTIVE_INDICATOR}
                    fieldType={FieldType.TEXT}
                    isReadOnly={true}
                    onFieldChange={() => { }} />
                <HPHCheckbox
                    label={""}
                    checked={currentEntity?.activeInd === 'Y'}
                    disabled={isEditable === false}
                    onChange={(e) => masterFSPVM.onCheckboxChange(e.checked, "activeInd")}
                />
            </div>
        </>
        , [SCREEN_CONSTANT.ACTIVE_INDICATOR, currentEntity?.activeInd, masterFSPVM, isEditable])

    const memoSplitFirstDays = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "330px", marginBottom: "24px" }}>
            {/*<NbisCommonField
                isReadOnly={!isCalcBySplitDay}
                isShowOptional={!isCalcBySplitDay}
                readOnlyValue={currentEntity?.splitFirstDays?.toString() ?? ''}
                fieldValue={currentEntity?.splitFirstDays?.toString()}
                fieldLabel={SCREEN_CONSTANT.SPLIT_FIRST_DAYS}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.TEXT}
                fieldKey={'splitFirstDays'}
                maxLength={10}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    masterFSPVM.onFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />*/}
            <NumberInputComponent
                label={SCREEN_CONSTANT.SPLIT_FIRST_DAYS}
                maxLength={60}
                width="330px"
                fieldName={"splitFirstDays"}
                value={currentEntity?.splitFirstDays ?? ''}
                errorMessage={allFormState?.splitFirstDays}
                disabled={!isCalcBySplitDay || isRead}
                onChange={(e: any, fieldKey: string, fieldValue: any) => onNumberFieldChange(e, fieldKey, fieldValue)}
            />
        </div>
        , [SCREEN_CONSTANT.SPLIT_FIRST_DAYS, currentEntity?.splitFirstDays, allFormState?.splitFirstDays, isCalcBySplitDay, isRead, onNumberFieldChange])

    const memoSplitFirstDaysTo = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "330px", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={!isCalcBySplitDay || isRead}
                isShowOptional={!isCalcBySplitDay || isRead}
                readOnlyValue={currentEntity?.splitFirstDaysTo ?? ''}
                fieldValue={currentEntity?.splitFirstDaysTo}
                fieldLabel={SCREEN_CONSTANT.SPLIT_FIRST_DAYS_TO}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'splitFirstDaysTo'}
                maxLength={10}
                options={masterFSPState.dynamicOptions.splitDaysToDropdownOptions}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    masterFSPVM.onFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [allFormState, isCalcBySplitDay, isRead, currentEntity?.splitFirstDaysTo, SCREEN_CONSTANT.SPLIT_FIRST_DAYS_TO, isSaveClicked, masterFSPState.dynamicOptions.splitDaysToDropdownOptions, masterFSPVM])

    const memoSplitRemainDaysTo = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "330px", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={!isCalcBySplitDay || isRead}
                isShowOptional={!isCalcBySplitDay || isRead}
                readOnlyValue={currentEntity?.splitRemainDaysTo ?? ''}
                fieldValue={currentEntity?.splitRemainDaysTo}
                fieldLabel={SCREEN_CONSTANT.SPLIT_REMAIN_DAYS_TO}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'splitRemainDaysTo'}
                maxLength={10}
                options={masterFSPState.dynamicOptions.splitDaysToDropdownOptions}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    masterFSPVM.onFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [allFormState, isCalcBySplitDay, isRead, currentEntity?.splitRemainDaysTo, SCREEN_CONSTANT.SPLIT_REMAIN_DAYS_TO, isSaveClicked, masterFSPState.dynamicOptions.splitDaysToDropdownOptions, masterFSPVM])

    const memoEditPanelTitleBar = useMemo(() => {
        return <MasterFSPEditPanelTitleBar />
    }, [])


    return <StyledSidebar style={{ width: '100%', height: "100%", border: 'none', backgroundColor: '#FFFFFF', overflow: 'auto', padding: '0' }} position='right'>
        {/* Header part of add or edit record */}
        {memoEditPanelTitleBar}

        {isLoading && <Loader Indicator="Spinner" size="Medium" />}
        {/* Readable and Editable Form */}
        <div className={'add-edit-form'} style={{ height: 'calc(100vh - 125px)', maxHeight: 'calc(100vh - 125px)', overflow: 'auto' }}>
            <div className="flex-row-auto">
                <div className={'flex-row-item'}>
                    <div className={'im-flex-row'}>
                        <div className={'flex-row-item-stretch'}>
                            {/*<SidebarTitle>{!isAdd ? currentEntity.masterFSPCode : "NEW CODE"}</SidebarTitle>*/}

                            {<SidebarCaption>"All fields are required unless indicated as 'optional'"</SidebarCaption>}
                        </div>
                    </div>

                    <CriteriaItemContainer>
                        {memoPriority}
                        {memoStatus}
                        {memoShippingLine}
                    </CriteriaItemContainer>
                    <CriteriaItemContainer>
                        {memoEffectiveDateFrom}
                        {memoEffectiveDateTo}
                        {memoConsortiumCode}
                    </CriteriaItemContainer>
                    <CriteriaItemContainer>
                        {memoServiceCode}
                        {memoChargeType}
                        {memoSubChargeType}
                    </CriteriaItemContainer>
                    <CriteriaItemContainer>
                        {memoShipmentType}
                        {memoCntrMovement}
                        {memoCntrStatus}
                    </CriteriaItemContainer>
                    <CriteriaItemContainer>
                        {memoAgentCode}
                        {memoFspCountingFrom}
                        {memoFspCountingTo}
                    </CriteriaItemContainer>
                    <CriteriaItemContainer>
                        {memoFspDays}
                        {memoFspUOM}
                        {memoCargoCode}
                    </CriteriaItemContainer>
                    <CriteriaItemContainer>
                        {memoCustomerType}
                        {memoVesselCode}
                        {memoVoyageCode}
                    </CriteriaItemContainer>
                    <CriteriaItemContainer>
                        {memoGraceHourFrom}
                        {memoGraceMinuteFrom}
                        {memoGraceHourTo}
                    </CriteriaItemContainer>
                    <CriteriaItemContainer>
                        {memoGraceMinuteTo}
                        {memoForwarderCode}
                        {memoForwarderReference}
                    </CriteriaItemContainer>
                    <CriteriaItemContainer>
                        {memoSplitFirstDays}
                        {memoSplitFirstDaysTo}
                        {memoSplitRemainDaysTo}
                    </CriteriaItemContainer>
                    <CriteriaItemContainer>
                        {memoFspCountingDirection}
                        {memoFspCalculateMethod}
                        {memoApplyCalendarAdj}
                    </CriteriaItemContainer>
                    <CriteriaItemContainer>
                        {memoRemarks}
                    </CriteriaItemContainer>
                    <CriteriaItemContainer>
                        {memoRejectReason}
                    </CriteriaItemContainer>
                    <CriteriaItemContainer>
                        {memoGraceExtend}
                        {memoActiveInd}
                    </CriteriaItemContainer>

                </div>
            </div>
        </div>
        {/* Readable and Editable Form */}
    </StyledSidebar>
}
